import {
  Grid,
  Users,
  Shield,
  Briefcase,
  Layers,
  Award,
  Percent,
  MinusCircle,
  Calendar,
  MapPin,
  Package,
  UserCheck,
  MessageCircle,
  Map,
  Settings,
  Truck,
  FileText,
  List,
  ArrowDownCircle,
  ArrowUpCircle,
  RotateCcw,
  Sliders,
  BarChart2,
  Compass,
} from "react-feather";

// Only screens that actually exist get a nav entry (handoff §9: most modules
// are still empty placeholders in the API) - each item's `permission` is a
// Module.Action code checked against the caller's claims, never a role name.
export const navSections = [
  {
    label: "Main",
    items: [{ label: "Dashboard", icon: Grid, path: "/dashboard" }],
  },
  {
    label: "Administration",
    items: [
      {
        label: "Users",
        icon: Users,
        path: "/admin/users",
        permission: "Admin.ManageUsers",
      },
      {
        label: "Roles",
        icon: Shield,
        path: "/admin/roles",
        permission: "Admin.ManageRoles",
      },
      {
        label: "Designations",
        icon: Briefcase,
        path: "/admin/designations",
        permission: "Admin.ManageDesignations",
      },
      {
        label: "Feedback",
        icon: MessageCircle,
        path: "/admin/feedback",
        permission: "Admin.ManageFeedback",
      },
      {
        label: "Settings",
        icon: Settings,
        path: "/admin/settings",
        permission: "Settings.ManageIntegrations",
      },
    ],
  },
  {
    // Live against /api/v1/masters/* (handoff §9, Milestone 3). Each page
    // now has its own {Page}.View/.Create/.Edit permission triad (§13.3) -
    // reading requires .View (checked here, same as Administration above),
    // writes are gated in-page via useMasterPermissions/useCustomerPermissions
    // (.Create/.Edit, plus an all-branch check for the global masters).
    label: "HR Masters",
    items: [
      { label: "Customers", icon: MapPin, path: "/masters/customers", permission: "Customers.View" },
      { label: "Customer Locations", icon: Map, path: "/masters/customers/locations-map", permission: "Customers.ViewLocation" },
      { label: "Products", icon: Package, path: "/masters/products", permission: "Products.View" },
      { label: "Employees", icon: UserCheck, path: "/masters/employees", permission: "Employees.View" },
      { label: "Vehicles", icon: Truck, path: "/masters/vehicles", permission: "Vehicles.View" },
      { label: "Departments", icon: Layers, path: "/masters/departments", permission: "Departments.View" },
      { label: "Designations", icon: Award, path: "/masters/designations", permission: "Designations.View" },
      { label: "Payee (Tax)", icon: Percent, path: "/masters/tax", permission: "Tax.View" },
      { label: "Deductions", icon: MinusCircle, path: "/masters/deductions", permission: "Deductions.View" },
      { label: "Holidays", icon: Calendar, path: "/masters/holidays", permission: "Holidays.View" },
      { label: "Areas", icon: Compass, path: "/masters/areas", permission: "Area.View" },
    ],
  },
  {
    // Own top-level module, against TexasAlarms.Api's src/Stock module
    // (LPO -> Stock-In/GRN -> Stock-Out -> Return -> Adjustment) - deliberately
    // not nested under HR Masters or Vehicles, per direct instruction.
    label: "Stock Management",
    items: [
      { label: "LPOs", icon: FileText, path: "/stock/lpos", permission: "Stock.ViewLpo" },
      { label: "Pending Vehicle Requests", icon: List, path: "/stock/lpos/pending-vehicle-requests", permission: "Stock.CreateLpo" },
      { label: "Stock-In (GRN)", icon: ArrowDownCircle, path: "/stock/stock-in", permission: "Stock.ViewStockIn" },
      { label: "Stock-Out", icon: ArrowUpCircle, path: "/stock/stock-out", permission: "Stock.ViewStockOut" },
      { label: "Stock Returns", icon: RotateCcw, path: "/stock/returns", permission: "Stock.ViewReturn" },
      { label: "Stock Adjustments", icon: Sliders, path: "/stock/adjustments", permission: "Stock.ViewAdjustment" },
      { label: "Stock Balances", icon: BarChart2, path: "/stock/balances", permission: "Stock.ViewBalance" },
    ],
  },
];
